<template>
    <BreadCrumb PageTitle=" Importation des marchands" />
      <ImportationUsager />
    </template>
    
    <script lang="ts">
      import { defineComponent } from "vue";
      import BreadCrumb from "../../components/Common/BreadCrumb.vue";  
      import ImportationUsager from "@/components/Importation/ImportationUsager.vue";
  
    
      export default defineComponent({
        name: "ImportationUsagerPage",
        components: {
            ImportationUsager,
        },
      });
    </script>